"use client";
import { AuthenticatedUser } from "@gettactic/api";
import { createContext, useContext } from "react";

const SetupAuthenticatedContext = createContext<AuthenticatedUser | undefined>(
  undefined
);

export function SetupAuthenticatedProvider({
  authenticatedUser,
  children
}: {
  authenticatedUser: AuthenticatedUser;
  children: React.ReactNode;
}) {
  return (
    <SetupAuthenticatedContext.Provider value={authenticatedUser}>
      {children}
    </SetupAuthenticatedContext.Provider>
  );
}

/**
 * Provides authenticated user context during setup process.
 */
export function useSetupAuthenticated() {
  const context = useContext(SetupAuthenticatedContext);
  if (context === undefined) {
    throw new Error(
      `useSetupAuthenticated must be used within a SetupAuthenticatedContext.Provider`
    );
  }
  return context;
}
